<template>
  <div class="page">
    <div class="header">
      <div class="description">
        <h1 class="title">Nova Consulta</h1>
      </div>
    </div>

    <new-query
      tag="cpf"
      consultations-route="/compliance/physical-person"
    />
  </div>
</template>

<script>
import NewQuery from '@/compliance/components/NewQuery.vue';

export default {
  name: 'Create',

  components: {
    NewQuery,
  },
};
</script>

<style lang="scss" scoped>

</style>
